










import { Component, Vue } from "vue-property-decorator";
import vesselNotes from "@/components/VesselNotes.vue";
import featureNotAvailable from "@/components/FeatureNotAvailable.vue";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";

const Vessels = getModule(VesselsModule, store);

@Component({
  components: {
    vesselNotes,
    featureNotAvailable,
  },
})
export default class VesselNotesView extends Vue {
  vessel = Vessels.currentVessel;

  get featureEnabled(): boolean {
    if (!this.vessel) return false;
    return this.vessel.features.some(feature => feature.name === "Notes");
  }

  get vesselId(): number {
    return parseInt(this.$route.params.vesselId);
  }
}
